// i18n area 'networks' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.sq-AL.meta.json.
import type { enUS } from './networks'

export const sqAL: typeof enUS = {
  networks: {
    common: {
      name: 'Emri',
      scope: 'Scope',
      operState: 'Gjendja',
      actions: 'Veprimet',
      create: 'Krijo',
      close: 'Mbyll',
      cancel: 'Anulo',
      delete: 'Fshi',
      edit: 'Modifiko',
      save: 'Ruaj',
      editError: 'Modifikimi nuk u krye',
      search: 'Kërko sipas emrit',
      empty: 'Ende asgjë këtu',
      saveError: 'Nuk mund të ruhej',
      loadError: 'Nuk mund të ngarkohej — a është i arritshëm backend-i TVirt?',
      createError: 'Krijimi nuk u krye',
      deleteError: 'Fshirja nuk u krye',
      deleteConfirmTitle: 'Të fshihet {name}?',
      deleteConfirmBody: 'Operacioni nuk është i kthyeshëm.',
      nameHint: 'Shkronja të vogla, shifra dhe vija ndarëse (DNS-1123)',
      up: 'Aktive',
      down: 'Joaktive',
      unknown: 'E panjohur',
      usedByVMs: 'VM',
      emptyTable: 'Asnjë zë — shto një me butonin +'
    },
    dialogTabs: {
      general: 'Të përgjithshme',
      base: 'Përkufizimi bazë',
      advanced: 'Konfigurimi i avancuar',
      reserved: 'Range të rezervuar për TVirt',
      position: 'Pozicioni',
      network: 'Konfigurimi i rrjetit',
      hosts: 'Nyjet pjesëmarrëse'
    },
    reservedRanges: {
      note: 'Këta janë range-t e IP-ve të rezervuar për TVirt, që ai mund t’i përdorë për t’u caktuar automatikisht një adresë VM-ve, kontejnerëve etj. SHËNIM: IP-të në këta range nuk duhet të përdoren jashtë TVirt nga shërbime/pajisje të jashtme.',
      from: 'Nga',
      to: 'Deri'
    },
    overlay: {
      title: 'Rrjetet overlay',
      createTitle: 'Krijo rrjet overlay',
      editTitle: 'Modifiko rrjetin overlay',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — caktohet automatikisht nëse bosh',
      subnet: 'Nënrrjeti',
      subnetHint: 'CIDR-i i overlay-it — IPAM-i e derivon automatikisht zërin e regjistrit',
      mtu: 'MTU',
      weight: 'Pesha',
      ceilMbps: 'Tavani (Mbps)',
      fairnessHint: 'Pesha vlen vetëm nën konkurrencë: në një lidhje të lirë çdo rrjet mund të përdorë gjithë brezin. Tavani vlen gjithmonë.',
      contention: 'Konkurrencë',
      contentionTip: 'Të paktën një nyje vëren humbje ose overlimit ME radhë në klasën e këtij rrjeti: brezi i uplink-ut është i kontestuar dhe peshat po veprojnë. Sa dhe që kur gjenden në seritë net.shaping.* të nyjes.',
      firewallPolicy: 'Politika firewall',
      hosts: 'Host',
      hostsTitle: 'Nyjet pjesëmarrëse',
      hostsHint: 'Secila nyjë deklaron endpoint-in e vet underlay — një select mbi adresat REALE të nyjes, të lexuara nga konfigurimi i saj i rrjetit; adresa overlay opsionale duhet të qëndrojë brenda nënrrjetit. Pjesëmarrja është kufizimi i placement-it.',
      hostNode: 'Nyja',
      hostUnderlay: 'IP underlay',
      hostUnderlayPickNode: 'Zgjidh më parë nyjën',
      hostAddress: 'Adresa në overlay (opsionale)',
      hostAddressOutside: 'Jashtë subnet-it të overlay-t ({cidr})',
      addHost: 'Shto nyjë',

      // Round #156 (dialog standard): le righe osservate del dialog dettagli.
      observedAt: 'Vëzhguar më',
      attachedNics: 'NIC të lidhura'
    },
    services: {
      title: 'Shërbimet e rrjetit',
      createTitle: 'Krijo shërbim rrjeti',
      editTitle: 'Modifiko shërbimin e rrjetit',
      kind: 'Tipi',
      kindCategory: 'Shërbimet',
      selectKindHint: 'Zgjidh tipin e shërbimit — demoni poshtë tij është një detaj implementimi që TVirt e menaxhon për ty.',
      kindLabel: {
        dhcp: 'Server DHCP',
        ntp: 'Server NTP',
        vpn: 'Server VPN',
        dns: 'Server DNS',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer dhe reverse proxy',
        floatip: 'IP lundruese'
      },
      kindDesc: {
        dhcp: 'Cakton adresa në nënrrjetet e shërbyera — pool-et derivojnë nga nënrrjeti, gateway-i dhe range-t e rezervuar për TVirt të rrjetit.',
        dns: 'DNS autoritativ mbi zonat e deklaruara — record-et derivojnë nga IPAM-i plus ata manualë të tutë.',
        gateway: 'Nyja bën gateway për një rrjet — NAT (DNAT, 1:1, SNAT/masquerade) plus routing statik mes rrjeteve të lidhura, vetë-riparues nga dizajni.',
        'lb-rp': 'Balancues / proxy i kundërt përpara shërbimeve tuaja — dëgjues L4 ose L7 mbi pool-e anëtarësh ose mbi instancat e gatshme të një Pod-i, të rikonfiguruar në fluturim.',
        ntp: 'Shërbimi i orës i rrjeteve — relay i serverëve upstream të jashtëm, ose ora e nyjes e shërbyer klientëve.',
        vpn: 'Një koncentrator VPN në nyjë — WireGuard ose OpenVPN, zgjedh ti: qasje në distancë për klientët shëtitës, ose një tunel site to site mes dy rrjeteve.',
        floatip: 'Një adresë që qëndron vetëm në një instancë App ose Pod të shëndetshme në një kohë dhe zhvendoset te objektivi tjetër i shëndetshëm kur ai bie — failover pa demonë; balancimi mbetet te balancuesi.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'IP-ja lundruese jeton në rrjetin e zgjedhur si adresë SHTESË brenda hapësirës së emrave të instancës mbajtëse: pa porta, pa balancim, pa NAT — IP-ja e klientit mbetet e vërtetë.',
        address: 'IP lundruese',
        targets: 'Objektivat',
        targetsHint: 'Sipas rendit të PREFERENCËS: objektivi i parë i shëndetshëm mban adresën. Një Pod vlen për të gjitha instancat e tij, sipas replikës; çdo objektiv ka kriterin e vet të shëndetit. Çdo objektiv duhet të jetë i lidhur me të njëjtin rrjet.',
        targetKind: 'Objektivi',
        targetApp: 'Instancë App',
        targetPod: 'Pod (të gjitha instancat)',
        targetRef: 'Cili',
        health: 'Shëndeti',
        healthRunning: 'Në ekzekutim (çdo kontejner gati)',
        healthTcp: 'Lidhje TCP',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Porta',
        path: 'Shtegu',
        addTarget: 'Shto objektiv',
        moveUp: 'Lëviz lart',
        moveDown: 'Lëviz poshtë',
        preempt: 'Preempt',
        preemptHint: 'Fikur (parazgjedhje): një mbajtës i shëndetshëm e mban adresën edhe kur kthehet një objektiv më i lartë — pa lëkundje. Ndezur: objektivi i parë i shëndetshëm e mban gjithmonë.',
        holder: 'Mbajtësi',
        noHolder: 'asnjë objektiv i shëndetshëm',
        since: 'që nga',
        verdicts: 'Objektivat e vëzhguar',
        healthy: 'i shëndetshëm',
        unhealthy: 'jo i shëndetshëm',
        noVerdict: 'Ende pa vendim — nyja e autoritetit shkruan verdiktin e parë në kalimin e saj të radhës.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Kjo instancë mban IP-në lundruese {address} të shërbimit {service}'
      },
      poolSource: 'Pikat fundore',
      poolSourceMembers: 'Anëtarë statikë',
      poolSourcePod: 'Instancat e gatshme të një Pod-i',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Porta',
      poolBackendHint: 'Pikat fundore ndjekin Pod-in: një instancë hyn kur ekzekutohet me çdo kontejner gati dhe del menjëherë kur zvogëlohet ose vdes. Kontrolli aktiv është i ndezur si parazgjedhje.',
      poolBackendCount: 'instancat e gatshme të Pod-it {pod} në portën {port}',
      node: 'Nyja',
      enabled: 'I aktivizuar',
      parked: 'I parkuar',
      subnets: 'Nënrrjetet',
      subnetsHint: 'Nënrrjetet IPAM të shërbyera nga kjo instancë — pool-et derivojnë nga CIDR-i, gateway-i dhe range-t e rezervuar për TVirt',
      noSubnets: 'Asnjë nënrrjet IPAM — deklaro më parë një rrjet logjik të fabric-ut (ose një nënrrjet overlay): IPAM-i derivon prej tyre',
      iface: 'Ndërfaqja e dëgjimit',
      ifaceHint: 'Ndërfaqja host mbi të cilën shërbimi hap socket-in e vet (p.sh. një bridge) — e detyrueshme: një shërbim rrjeti është i vetëpërmbajtur, "të gjitha ndërfaqet" nuk ekziston më',
      dns: 'Serverët DNS',
      domain: 'Domeni',
      detail: 'Shërben',
      subnetCount: '{n} nënrrjete',
      zones: 'Zonat',
      zonesHint: 'Vetëm autoritativ — demoni nuk bën kurrë rekursion. Record-et A derivojnë nga adresat e deklaruara të nyjeve në nënrrjetet IPAM të referuara; switch-i reverse shërben edhe zonat përkatëse in-addr.arpa (PTR). Një zonë shërbehet nga të shumtën një instancë DNS në flotë. Nameserver-i opsional është FQDN-ja e shkruar në record-et NS/SOA në vend të default-it ns.<zona>; nëse bie brenda zonës, record-i i tij A derivon gjithsesi nga nyja shërbyese.',
      zoneName: 'Emri i zonës',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'Nënrrjetet IPAM',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Record-e manualë',
      zoneRecordsHint: 'Një për rresht: emër TIP vlerë — tipet A, CNAME, MX, TXT. Në rast përplasjeje mbi emrin, record-i manual fiton mbi atë të derivuar.',
      addZone: 'Shto zonë',

      // lb-rp (wave 3 fondamenta): listener su pool inline — engine-less,
      // riconfigurato in volo.
      lbListeningHint: 'Instanca deklaron NJË rrjet dëgjimi dhe NJË adresë — secili listener e lidh në portën e vet; një adresë e dytë është një shërbim i dytë.',
      listeners: 'Listener',
      listenersHint: 'Secili listener e lidh adresën e instancës në portën e vet në mënyrën L4 (passthrough TCP — byte-t nuk hapen kurrë) ose L7 (HTTP) dhe përcjell te njëri nga pool-et këtu poshtë. Një çift adresë/portë shërbehet nga të shumtën një instancë për nyjë. Ndryshimet zbatohen në fluturim — asnjë rinisje, asnjë lidhje e humbur.',
      listenerName: 'Emri',
      listenerMode: 'Mënyra',
      modeL7: 'L7 — reverse proxy HTTP',
      modeL4: 'L4 — passthrough TCP',
      listenerPort: 'Porta',
      listenerPool: 'Pool',
      addListener: 'Shto listener',
      pools: 'Pool',
      poolsHint: 'Backend-et ku zbret trafiku: anëtarë statikë të balancuar round-robin ose nga më pak i zëni, me një health check aktiv opsional që i heq nga rotacioni anëtarët e sëmurë.',
      poolName: 'Emri',
      poolAlgorithm: 'Algoritmi',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Më pak i zëni',
      poolCheck: 'Health check',
      checkNone: 'Asnjë',
      checkTcp: 'Lidhje TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Shtegu i sondës',
      poolInterval: 'Intervali (s)',
      poolMembers: 'Anëtarët',
      poolMembersHint: 'Një për rresht: adresë:portë, opsionalisht e ndjekur nga një peshë (1-128) — p.sh. 10.0.0.21:8080 2',
      addPool: 'Shto pool',
      memberCount: '{n} anëtarë',

      // ntp (round ntp — ratifica 2026-08-03, l'ultimo kind della famiglia):
      // il modo in parole parlate, la lista upstream solo dove significa
      // qualcosa, l'attacco di rete riusa le etichette del gateway.
      // #239 (netsvc autocontenuti): l'editor condiviso della lista di
      // listener dei kind dns e ntp — le due eccezioni multi-rete ratificate.
      listen: {
        assignment: 'Caktimi',
        assignmentStatic: 'Adresë statike',
        assignmentAuto: 'Automatike (intervalet e rezervuara TVirt)',
        autoHint: 'TVirt e nxjerr adresën nga intervalet e rezervuara të rrjetit logjik dhe e mban sticky — kurrë e rinxjerrë në një edit ose failover.',
        title: 'Listener',
        hint: 'Një shërbim rrjeti është i vetëpërmbajtur: secili listener deklaron rrjetin e vet (overlay, rrjet logjik i fabric-ut ose ndërfaqe) dhe një adresë brenda nënrrjetit të tij — një listener për adresë, wildcard-i nuk ekziston më. DNS dhe NTP mund të dëgjojnë në më shumë rrjete dhe në më shumë adresa të atyre rrjeteve.',
        address: 'Adresa e dëgjimit',
        add: 'Shto listener'
      },
      ntp: {
        mode: 'Mënyra e sinkronizimit',
        modeRelay: 'Relay i serverëve të jashtëm',
        modeNodeClock: 'Ora e nyjes',
        modeHint: 'Relay-i shërben orën e marrë nga serverët upstream të deklaruar; ora e nyjes shërben orën e nyjes shërbyese — të cilën klasteri e mban gjithsesi të sinkronizuar',
        servers: 'Serverët upstream',
        serversHint: 'Të ndarë me presje — hostname ose adresë IP; shërbimi e merr orën prej këtu dhe ia shërben rrjetit',
        port: 'Porta e dëgjimit',
        listening: 'Në dëgjim mbi'
      },

      vpn: {
        engine: 'Motori',
        engineHint: 'E zgjedh ti, dhe nuk ndryshon më: WireGuard është modern, i shpejtë dhe in-kernel; OpenVPN është veterani i përputhshmërisë (TCP, rrjete armiqësore)',
        engineLocked: 'Motori është i pandryshueshëm — një motor tjetër është një shërbim i ri, çelësat dhe certifikatat nuk janë të bartshme',
        mode: 'Mënyra',
        modeRemote: 'Qasje në distancë',
        modeSite: 'Site to site',
        modeHint: 'Qasja në distancë u jep klientëve shëtitës një adresë në tunel; site to site bashkon dy rrjete',
        port: 'Porta e dëgjimit',
        protocol: 'Transporti',
        protocolWireguardHint: 'WireGuard flet vetëm UDP',
        tunnelSubnet: 'Nënrrjeti i tunelit',
        tunnelSubnetHint: 'Rrjeti ku jetojnë klientët — i regjistruar në regjistrin IPAM, lind dhe vdes me këtë shërbim',
        dnsServers: 'DNS të shtyrë te klientët',
        routes: 'Rrugë të shtyra te klientët',
        routesHint: 'Rrjete të ndara me presje të arritshme në tunel; nënrrjeti i tunelit përfshihet gjithmonë',
        peers: 'Peer',
        peersHint: 'Lëre bosh çelësin publik dhe TVirt e gjeneron çiftin — pastaj e dorëzon me profilin. Ngjit një çelës dhe peer-i mban të vetin.',
        clients: 'Klientët',
        clientsHint: 'Secili klient merr një certifikatë të lëshuar nga CA e këtij shërbimi. Heqja e një klienti e REVOKON: CRL-ja rigjenerohet menjëherë.',
        peerName: 'Emri',
        publicKey: 'Çelësi publik',
        publicKeyMinted: 'E gjeneron TVirt',
        peerAddress: 'Adresa në tunel',
        peerAddressHint: 'Bosh = e caktuar',
        allowedIps: 'Nënrrjetet në distancë',
        allowedIpsHint: 'Të ndara me presje, të rrugëzuara përmes këtij peer-i',
        endpoint: 'Endpoint',
        presharedKey: 'Çelësi i para-ndarë',
        keepalive: 'Keepalive (s)',
        addPeer: 'Shto peer',
        addClient: 'Shto klient',
        auth: 'Autentikimi',
        authTls: 'Certifikata (TLS)',
        remote: 'Endpoint-i në distancë',
        remoteHint: 'host:portë e skajit në distancë — bosh do të thotë që kjo anë pret',
        peerRoutes: 'Nënrrjetet në distancë',
        serverPublicKey: 'Çelësi publik i këtij serveri',
        ca: 'Autoriteti i certifikimit',
        listening: 'Në dëgjim mbi',
        tunnel: 'Tuneli',
        peerCount: '{n} peer',
        download: 'Shkarko profilin',
        downloadError: 'Profili nuk mund të eksportohej',
        lastHandshake: 'Handshake-u i fundit',
        never: 'kurrë',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'I lidhur',
        idle: 'Joaktiv'
      },

      // Gateway (wave 3 — nato nat, ratifica 2026-08-01/02; rinominato ed
      // esteso il 2026-08-03): le tre famiglie di regole NAT più le rotte
      // statiche su una rete di listening. Ogni forma ratificata è supportata.
      gateway: {
        attach: 'Tipi i rrjetit të dëgjimit',
        attachOverlay: 'Rrjet overlay',
        attachNetwork: 'Rrjet logjik i fabric-ut',
        attachInterface: 'Ndërfaqe e papërpunuar',
        overlay: 'Rrjeti overlay',
        network: 'Rrjeti logjik',
        interface: 'Emri i ndërfaqes',
        interfaceHint: 'Një ndërfaqe host që TVirt nuk e menaxhon — adresa merret siç është',
        address: 'Adresa e dëgjimit (gateway)',
        addressHint: 'Adresa gateway te e cila drejtohen klientët — brenda nënrrjetit të rrjetit të dëgjimit',
        dnatTitle: 'Rregullat DNAT',
        dnatHint: 'NAT destinacioni: trafiku brenda match-it ridrejtohet te një adresë e re (dhe opsionalisht një portë e re). Çfarëdo protokolli nga lista — portat aty ku protokolli i mbart.',
        snatTitle: 'Rregullat SNAT',
        snatHint: 'NAT burimi: trafiku brenda match-it del me burimin të rishkruar — një adresë e re eksplicite (dhe opsionalisht një portë e re), ose masquerade mbi adresën e daljes nëse lihet bosh.',
        oneToOneTitle: 'Rregullat 1:1 NAT',
        oneToOneHint: 'Çdo paketë për adresën e jashtme përkthehet te e brendshmja, dhe host-i i brendshëm del si i jashtmi — të gjithë protokollet, të dyja drejtimet.',
        external: 'Adresa e jashtme',
        internal: 'Adresa e brendshme',
        addOneToOne: 'Shto rregull 1:1',
        family: 'Familja',
        protocol: 'Protokolli',
        source: 'Burimi (adresë/nënrrjet)',
        destination: 'Destinacioni (adresë/nënrrjet)',
        invert: 'NOT',
        srcPorts: 'Portat burim',
        dstPorts: 'Portat dest.',
        dstPortsHint: 'Portë ose range (80, 8000-8099)',
        toAddress: 'Adresa e re',
        toPort: 'Porta e re',
        snatTo: 'Burimi i ri (bosh = masquerade)',
        snatToHint: 'Adresë burimi eksplicite; bosh = masquerade mbi adresën e daljes',
        addDnat: 'Shto rregull DNAT',
        addSnat: 'Shto rregull SNAT',
        routesTitle: 'Rrugë statike',
        routesHint: 'Nyja rrugëzon mes rrjeteve ku është e lidhur (IP forwarding-u është aktiv); këto rrugë shtojnë arritshmëri përtej atyre — kernel i pastër, routing-u dinamik vjen me një round të mëvonshëm.',
        routeDestination: 'Nënrrjeti i destinacionit',
        routeGateway: 'Next hop',
        routeMetric: 'Metrika',
        addRoute: 'Shto rrugë',
        listening: 'Në dëgjim mbi',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} rrugë'
      },
      unknownSince: 'I panjohur — raporti i fundit para {m} min',
      lastWord: 'Fjala e fundit',

      // Round #156 (dialog standard): le righe osservate e il riepilogo in
      // sola lettura del blocco kind nel dialog dettagli.
      reportObservedAt: 'Raporti i fundit',
      lastErrorRow: 'Gabimi i fundit',
      recordsCount: '{n} record-e manualë',
      phase: {
        configured: 'I konfiguruar',
        running: 'Në ekzekutim',
        error: 'Gabim'
      },
      authorityNode: 'Authority (caktimi)',
      preferredNode: 'Nyja e preferuar',
      preferredNodeHint: 'Një preferencë e butë, kurrë një detyrim: në vendimin e ardhshëm të placement-it instanca zbret këtu nëse anëtari është i pranueshëm — më vete nuk lëviz asgjë; lëvizja është "Transfero authority-n".',
      noPreference: 'Asnjë preferencë (placement automatik)',
      moving: 'Në lëvizje',
      movingTooltip: 'Vëzhguar këtu ndërsa authority cakton {node}: lëvizja po konvergon.',
      placement: {
        title: 'Placement',
        loading: 'Regjistrim në vazhdim…',
        loadError: 'Regjistrimi i placement-it nuk u përgjigj — riprovo më vonë.',
        draftHint: 'Regjistrimi llogaritet mbi lidhjen e deklaruar të rrjetit: do të shfaqet sapo shërbimi të krijohet. Krijimi refuzohet nëse asnjë anëtar nuk mund ta shërbejë, dhe refuzimi emërton mekanizmin që e zbrazi bashkësinë.',
        eligibleCount: '{n} nga {m} anëtarë mund ta shërbejnë këtë instancë',
        recommended: 'I rekomanduar',
        eligible: 'I pranueshëm',
        notEligible: 'I papranueshëm',
        blockedReachability: 'rrjeti nuk arrin te ky anëtar',
        blockedRequireTag: 'bllokuar nga një tag i kërkuar (requireNodes)',
        blockedExcluded: 'përjashtuar nga simulimi',
        preferenceUnknown: 'nuk është (më) anëtar i klasterit',
        preferenceIgnored: 'Preferenca "{node}" sot nuk është e pranueshme: {reason}. Mbizotëron rekomandimi i regjistrimit — kurrë një gabim, shërbimi jeton gjetkë.',
        emptyReachability: 'Asnjë anëtar nuk mund ta shërbejë këtë instancë: rrjeti nuk arrin askund — asnjë retushim i tag-eve nuk do të ndihmojë. Lidhe nyjen me kabllo, ose zhvendose shërbimin atje ku është rrjeti.',
        emptyRequireTag: 'Asnjë anëtar nuk mund ta shërbejë këtë instancë: janë tag-et e kërkuar ata që e zbrazën bashkësinë — hiqe zërin nga requireNodes, ose vendosi një tag një anëtari.',
        spof: 'Pikë e vetme dështimi',
        spofDetail: 'Vetëm një anëtar mund ta strehojë instancën: në dështim failover-i nuk ka ku të shkojë. Një shërbim me shumë listener-ë zhvendoset si NJËSI — kandidati duhet t\'i shohë TË GJITHA rrjetet e tij: ky është çmimi.',
        whatIf: 'Simulo anëtarë që mungojnë',
        whatIfHint: 'What-if-i i drain-it: pyet PARA evakuimit, mos e zbulo në failover.',
        survives: 'Me {nodes} në mungesë, shërbimi ka ende një shtëpi.',
        notSurvives: 'Evakuimi i {nodes} e lë këtë shërbim POSHTË: detyrimi i derivuar fiton mbi disponueshmërinë (R30) — një daemon i gjallë atje ku rrjeti nuk arrin nuk i shërben askujt dhe nuk alarmon askënd.',
        transfer: 'Transfero authority-n',
        transferError: 'Transferimi dështoi',
        transferTarget: 'Anëtari i destinacionit',
        transferHint: 'Propozohen vetëm anëtarët e pranueshëm — një preferencë brenda bashkësisë së vlefshme, kurrë një override. Asnjë task: kalimi i ardhshëm i worker-ëve ËSHTË lëvizja (nyja e vjetër korr, e reja e ngre).'
      }
    },
    fabric: {
      tabDerivation: 'Derivimi',
      importNetwork: 'Importo nga një fabric tjetër',
      importTitle: 'Importo një rrjet logjik',
      importHint: 'Importi është anëtarësimi i shprehur: rrjeti mbetet i titullarit (i njëjti identitet, i njëjti stem, i njëjti bridge tvf-<stem>) dhe që këtu hartëzohet në portat/LAGG-et e këtij fabric — të hartëzosh DO TË THOTË të pohosh se dorëzimi del në të njëjtin domen L2 si ai i titullarit.',
      importPick: 'Rrjeti i titullarit',
      importNone: 'Asgjë për t’u importuar: fabric-et e tjera nuk kanë asnjë rrjet të vetin që ky fabric të mos e njohë tashmë',
      importedNetworksTitle: 'Rrjete të importuara',
      noImported: 'Asnjë rrjet i importuar',
      importedFrom: 'importuar nga {fabric}',
      importedBy: 'Importuar nga: {list}',
      importedCount: '+{n} të importuara',
      owner: 'Titullari',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Hiq importin',
      unimportConfirm: 'Të hiqet importi i rrjetit {name} (titullar {fabric}) nga ky fabric? Refuzohet sa kohë që një portë ose LAGG i këtij fabric e hartëzon, ose një guest, App a shërbim shërbehet vetëm përmes kësaj këmbe.',
      unimportRefused: 'Importi ende në përdorim — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Kjo nyje e merr tashmë atë rrjet nga një fabric tjetër ku është anëtare: një nyje e merr një rrjet të ndarë vetëm nga NJË nga këmbët e saj (dy uplink të të njëjtit L2 në një bridge pa STP janë një lak). Hiqe hartëzimin në portat ose LAGG-in e njërit prej dy fabric-eve.',
          otherFabricDerived: 'Dokumenti mban bllokun e një fabric drejt të cilit nyja nuk deklaron më asnjë kabllo: apliko fillimisht planin e atij fabric (propozon heqjen e pajisjeve të tij), ose merri në zotërim me take-ownership nëse fabric-u nuk ekziston më.'
        },
        hint: 'Plani i derivimit O.3: për çdo nyje të kabluar gjendja, diff-i i derivuar-vs-aktual, topologjia e DEKLARUAR e bondeve, flip-et dual-stack dhe refuzimet/paralajmërimet e strukturuara. Vetëm lexim deri në apply-in EKSPLICIT — asgjë nuk zbret kurrë vetë mbi një nyje.',
        refresh: 'Ringarko planin',
        empty: 'Asnjë nyje nuk është e kabluar në këtë fabric (dhe asnjëra nuk mban më bllokun e tij).',
        refusal: 'Refuzim',
        warning: 'Paralajmërim',
        generation: 'gjenerata e dokumentit {n}',
        state: {
          manual: 'Manual',
          derived: 'I derivuar',
          diverged: 'I shmangur'
        },
        topologyTitle: 'Topologjia e deklaruar',
        members: 'anëtarët',
        primary: 'parësor',
        held: 'mbajtur në NJË anëtar',
        form: {
          perNetworkBond: 'Bond për rrjet',
          singleBond: 'Bond i vetëm rezervë',
          laggBond: 'Bond LACP (LAGG)',
          singlePort: 'Portë e vetme'
        },
        colAction: 'Veprim',
        colKind: 'Lloj',
        colDevice: 'Device',
        colDetail: 'Detaj',
        action: {
          add: 'shto',
          remove: 'hiq',
          replace: 'zëvendëso'
        },
        diffEmpty: 'Asnjë diff në pritje — dokumenti i aplikuar përputhet me render-in.',
        diffBlocked: 'Asnjë diff: refuzimet më lart bllokojnë këtë nyje.',
        phasePlanned: 'planifikuar (hapi 1 nga 3)',
        phaseDraining: 'po zbrazet (hapi 2 nga 3)',
        probeUnobserved: 'Sonda e zbrazjes: kurrë e raportuar — zbrazëtia është E PANJOHUR (një retire tani do të refuzohej).',
        probeFailed: 'Sonda e zbrazjes: vëzhgimi DËSHTOI — vulat kohore të njohura barten, kurrë një «bosh» që askush s\'e ka matur.',
        probeActive: {
          one: 'Sonda: {n} lidhje e vendosur ende në adresën e vjetër',
          other: 'Sonda: {n} lidhje të vendosura ende në adresën e vjetër'
        },
        probeLastActive: 'aktiviteti i fundit {time}',
        probeEmpty: {
          one: 'Sonda: bosh prej {n} minute',
          other: 'Sonda: bosh prej {n} minutash'
        },
        probeEmptyUnknown: 'Sonda: bosh (që kur, e panjohur).',
        impact: '{nics} vNIC dhe {apps} App në këtë nyje përdorin këto rrjete: {list}',
        apply: 'Apliko në këtë nyje',
        applyTitle: 'Apliko derivimin — {node}',
        applyIntro: 'Konfigurimi i derivuar rishkruan dokumentin e rrjetit të {node} ({n} ndryshime) nga e njëjta derë si editori host-network — checkpoint i NetworkManager dhe sonda e ndershme përfshirë. Paralajmërimet e planit më poshtë udhëtojnë me aktin: lexojini para se të konfirmoni.',
        applyError: 'Apply dështoi',
        applyRefused: 'Nyja refuzoi:',
        planMoved: 'Fabric-u ndryshoi pas kësaj parapamjeje — ASGJË nuk u aplikua. Plani u ringarkua: shikoni përsëri dhe riprovoni.',
        retire: 'Tërhiq',
        retireTitle: 'Pika pa kthim — tërheqja e {address}',
        restore: 'Rikthe',
        restoreTip: 'Kthehu te snapshot-i para apply (gjenerata {previous}) — zhbërja me një hap (H13)',
        restoreTitle: 'Rikthe dokumentin e mëparshëm — {node}',
        restoreIntro: 'Dokumenti i rrjetit i {node} kthehet te snapshot-i i marrë para apply-t të fundit (gjenerata {previous}), i rishkruar si gjenerata {next} në vend të {current}. Worker-i e konvergon si çdo dokument tjetër.',
        restoreRedo: 'Dokumenti i zëvendësuar bëhet snapshot-i i ri: rikthimi sërish është redo.',
        restoreClosesChain: 'Snapshot-i është dokumenti manual para derivimit: zinxhiri mbyllet këtu — asnjë zhbërje tjetër, nyja mbetet manuale deri në apply-n e ardhshëm.',
        restoreConfirm: 'Rikthe',
        restoreError: 'Rikthimi dështoi',
        retireIntro: 'Kjo heq {address} ({network}) nga {point} përfundimisht. Pas këtij akti rruga e kthimit është flip-i i ANASJELLTË — rideklarimi i adresës së vjetër përmes të njëjtit motor — kurrë një rikthim i verbër.',
        retireOld: 'Adresa e vjetër (hequr)',
        retireNew: 'Adresa e re (mbetet)',
        retireEmptyFact: 'Sonda e zbrazjes raporton adresën bosh: kjo heqje nuk pret asnjë lidhje të vëzhguar.',
        retireConfirm: 'Tërhiq adresën',
        severActiveLoss: {
          one: 'Prit {n} lidhje të vendosur ende në adresën e vjetër — vdes me këtë akt',
          other: 'Prit {n} lidhje të vendosura ende në adresën e vjetër — vdesin me këtë akt'
        },
        severUnknownLoss: 'Prano të PANJOHURËN: sonda kurrë nuk e ka vëzhguar këtë adresë (ose vëzhgimi dështon) — lidhje të gjalla mund të priten.'
      },
      title: 'Fabric',
      createTitle: 'Krijo fabric',
      networks: 'Rrjetet',
      switches: 'Switch',
      ports: 'Portat',
      laggs: 'LAGG',
      subnets: 'Nënrrjetet',
      tabOverview: 'Panorama',
      tabNetworks: 'Rrjetet logjike',
      tabSwitches: 'Switch',
      overviewHint: 'Fabric-u me një vështrim: çdo rrjet logjik me MTU dhe nënrrjet (VLAN-et jetojnë vetëm në përkthimet për-portë/për-LAGG — i njëjti rrjet mund të udhëtojë me tag-e të ndryshëm në porta të ndryshme). Fabric-u është regjistri i një infrastrukture TË JASHTME — TVirt vëzhgon dhe deklaron, nuk bën kurrë provisioning, dhe prek vetëm NIC-et e regjistruara nën kontrollin e tij.',
      absorptionHint: 'Çdo nënrrjet i deklaruar këtu e DERIVON zërin e vet në regjistrin IPAM në të njëjtën shkrirje — jeton dhe vdes me rrjetin.',
      scopeFixedHint: 'Scope është i fiksuar në rrënjën e klasterit: infrastruktura fizike është sipas përkufizimit në nivel klasteri.',
      networksHint: 'Çdo rrjet mbart një MTU të detyrueshme (default 1500) dhe një nënrrjet të detyrueshëm; gateway-i, serverët DNS dhe rrugët statike të deklaruara këtu janë BURIMI I VETËM për NIC-et e serverëve, App-et dhe shërbimet e rrjetit.',
      switchesHint: 'Regjistri manual: një portë është e papërdorur, e përkthyer (trafik untagged dhe për tag VLAN mbi rrjetet logjike) ose anëtare e një LAGG-u — një anëtare nuk mbart përkthime të vetat.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'I detyrueshëm — IPAM-i e derivon automatikisht zërin e regjistrit',
      nodeAddressing: 'Adresimi i nyjeve',
      nodeAddressingNone: 'Asnjë — pa adresë për nyje',
      nodeAddressingPool: 'Pool — një adresë e qëndrueshme për çdo nyje të shërbyer',
      nodeAddressingHint: 'Me Pool, derivimi i fabric-ut i cakton çdo nyjeje të shërbyer një adresë nga intervalet e rezervuara për TVirt (e qëndrueshme pasi caktohet).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Range të rezervuar',
      dns: 'Serverët DNS (të ndarë me presje)',
      dnsShort: 'DNS',
      singleSourceHint: 'Gateway-i, DNS-i dhe rrugët e deklaruara këtu janë burimi i vetëm — NIC-et e serverëve, App-et dhe shërbimet e rrjetit marrin prej këtu',
      routesTitle: 'Rrugë statike',
      routeDestination: 'Destinacioni (CIDR)',
      routeVia: 'Përmes (next hop)',
      portUsed: 'E përdorur',
      vlanMappings: 'Mapping VLAN',
      vlanTag: 'Tag VLAN',
      vlanNetwork: 'Rrjeti logjik',
      nameTaken: 'Emër tashmë i përdorur në fabric',
      addNetwork: 'Shto rrjet',
      editNetwork: 'Modifiko rrjetin',
      deleteNetwork: 'Hiq rrjetin',
      deleteNetworkConfirm: 'Të hiqet rrjeti logjik {name} nga fabric-u? Nënrrjeti i tij i derivuar në IPAM vdes bashkë me të (refuzohet derisa një shërbim ose një App ta përdorë). Mapimet e portave dhe LAGG-eve që e referojnë pastrohen.',
      switchName: 'Switch',
      portName: 'Porta',
      positionHint: 'Pozicion fizik (opsional) — i njëjti fjalor i pozicionimit të serverëve; vetëm deklarativ',
      addSwitch: 'Shto switch',
      editSwitch: 'Modifiko switch-in',
      deleteSwitch: 'Hiq switch-in',
      deleteSwitchConfirm: 'Të hiqet switch-i {name} me të gjitha portat e tij? LAGG-et ngushtohen si pasojë (dhe vdesin nën dy porta).',
      addPort: 'Shto portë',
      editPort: 'Modifiko portën',
      deletePort: 'Hiq portën',
      deletePortConfirm: 'Të hiqet porta {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:rrjet)',
      taggedShort: 'Tagged',
      portCabling: 'Kabllimi',
      portState: 'Gjendja',
      stateUnused: 'e papërdorur',
      stateMapped: 'e përkthyer',
      laggPortGuard: 'Një portë anëtare e një LAGG-u modifikohet nga ana e LAGG-ut',
      laggsTitle: 'LAGG',
      laggsHint: 'Një LAGG është 2+ porta në LACP dhe mund t’i kapërcejë switch-et (MLAG, transparent); hyjnë vetëm porta të papërdorura, LAGG-u është sipërfaqja e përkthimit, një portë e hequr kthehet e papërdorur.',
      addLagg: 'Shto LAGG',
      editLagg: 'Modifiko LAGG-un',
      deleteLagg: 'Hiq LAGG-un',
      deleteLaggConfirm: 'Të hiqet LAGG-u {name}? Portat e tij anëtare kthehen të papërdorura.',
      lacpRate: 'Rate LACP',
      laggPorts: 'Portat anëtare (2+)',
      laggPortsHint: 'Hyjnë vetëm porta të papërdorura — liro më parë një portë të përkthyer',
      noNetworks: 'Asnjë rrjet logjik i deklaruar.',
      noSwitches: 'Asnjë switch i deklaruar.',
      noLaggs: 'Asnjë LAGG i deklaruar.',
      staleConflict: "Një operator tjetër e ndryshoi këtë fabric ndërsa ti po e redaktoje: ruajtja u refuzua që të mos fshihet puna e tij. Ndryshimet e tua janë ende këtu, të paprekura. Fabric-u i përditësuar është ngarkuar tashmë sërish: konfirmo sërish që t'i zbatosh mbi të, ose anulo dhe shiko çfarë ndryshoi."
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Vetëm i derivuar: çdo nënrrjet lind nga një rrjet logjik i fabric-ut ose nga një overlay — modifikohet te burimi. Adresat e caktuara tregojnë KUSH i mban; range-t e rezervuar për TVirt janë pool-et e caktimit automatik.',
      search: 'Kërko sipas emrit, CIDR-it ose adresës',
      empty: 'Asnjë rrjet — deklaro një rrjet logjik të fabric-ut ose një nënrrjet overlay: IPAM-i derivon prej tyre automatikisht.',
      reserved: 'Range të rezervuar për TVirt',
      address: 'Adresa',
      origin: 'Prejardhja',
      origin_declared: 'e deklaruar',
      origin_observed: 'e vëzhguar',
      holder: 'Mbajtur nga',
      noAddresses: 'Asnjë adresë e njohur në këtë nënrrjet.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Modifiko te burimi'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Grupet firewall',
      createTitle: 'Grup i ri firewall',
      editTitle: 'Modifiko grupin firewall',
      empty: 'Ende asnjë grup firewall — krijo një: një fjalor rregullash i ripërdorshëm, i referuar me emër nga NIC-et e mysafirëve.',
      nameHint: 'Shkronja, shifra dhe . - _ të brendshme; unik brenda scope-it të vet (emërnjëjtët gjetkë dallohen me /scope/emër)',
      description: 'Përshkrimi',
      descriptionHint: 'Një rresht qëllimi, i shfaqur kudo ku zgjidhet grupi',
      enforced: 'I imponuar në scope',
      enforcedHint: 'I fikur: fjalor i pastër — rregullat lidhin vetëm NIC-et që e referojnë grupin. I ndezur: rregullat lidhin çdo NIC mysafiri me firewall-in të ndezur nën scope-in e grupit, të referuara ose jo.',
      enforcedChip: 'I imponuar',
      enforcedChipHint: 'Rregullat lidhin çdo NIC mysafiri me firewall-in të ndezur nën scope-in e grupit, të referuara ose jo',
      enforceWarning: 'Duke aktivizuar imponimin, rregullat lidhin ÇDO NIC mysafiri me firewall-in të ndezur nën {scope} në harmonizimin e ardhshëm, edhe pa referencë eksplicite — dhe brenda një chain-i aktiv drop-i i një paraardhësi është përfundimtar: nivelet poshtë nuk e rihapin.',
      unenforceInfo: 'Duke hequr imponimin, rregullat mbeten vetëm në NIC-et që e referojnë grupin eksplicitisht.',
      rules: 'Rregullat',
      tabOverview: 'Panorama',
      tabRules: 'Rregullat',
      orderHint: 'Rendi i rreshtave ËSHTË rendi i vlerësimit brenda grupit: fiton rregulli i parë që përputhet.',
      statefulHint: 'Stateful-i është implicit: përgjigjet ndaj trafikut të pranuar kalojnë vetë (established/related pranohen, invalid hidhet — i injekton motori, nuk shkruhen me dorë).',
      noRules: 'Asnjë rregull — një fjalor në ndërtim: ta referosh është e lejueshme dhe nuk prodhon asgjë.',
      addRule: 'Shto rregull',
      direction: 'Drejtimi',
      directionIn: 'Në hyrje',
      directionOut: 'Në dalje',
      action: 'Veprimi',
      action_accept: 'Prano',
      action_drop: 'Hidh',
      action_reject: 'Refuzo',
      protocol: 'Protokolli',
      protocolAny: 'Çfarëdo',
      ports: 'Portat',
      source: 'Burimi',
      dest: 'Destinacioni',
      comment: 'Komenti',
      addressHint: 'CIDR IPv4 ose <fabric>/<rrjet logjik>; bosh = çfarëdo',
      moveUp: 'Lëviz lart',
      moveDown: 'Lëviz poshtë',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Grupet firewall',
      nicGroupsPlaceholder: 'Zgjidh një grup…',
      nicGroupsHint: 'Grupet e dukshme, përfshirë ato të scope-eve të sipërm (të përdorshme poshtë, si tag-et)',
      nicGroupCount: { one: '{n} grup firewall', other: '{n} grupe firewall' },
      nicOff: 'Firewall i fikur',
      pendingRestartHint: 'Ndryshimet e firewall-it ndjekin modelin i ruajtur/i aplikuar: presin power cycle-in e ardhshëm (PendingRestart). Grupet e imponuara nga scope-et e sipërm aplikohen kur firewall-i i NIC-ut është i ndezur.',
      appConvergeHint: 'Ndryshimet e firewall-it aplikohen në harmonizimin e ardhshëm të kontejnerit. Grupet e imponuara nga scope-et e sipërm aplikohen kur firewall-i është i ndezur.',
      enforcedAncestors: 'Të imponuar nga scope-et e sipërm',
      enforcedAncestorsHint: 'Ky grup aplikohet mbi çdo NIC nën scope-in e vet me firewall-in të NDEZUR — çelësi është çelësi kryesor i NIC-ut (i fikur = asnjë chain fare, paraardhësit përfshirë); brenda një chain-i aktiv autoriteti i paraardhësit është përfundimtar: drop-i i tij nuk rihapet poshtë.'
    }
  }
}
